interface OrderedPageFilter {
  pageNumber: number
  pageSize: number
  orderColumn: string
  orderDescending: boolean
  searchValue?: string | null
  categoryId?: number | string | null
  dateOfService?: string | null
  lastModifiedAt?: string | null
}
export interface FilterPaged {
  items: any[]
  pageCount: number
  pageNumber: number
  pageSize: number
  totalItemsCount: number
  searchValue?: string
  fromDate?: Date
  endDate?: Date
}
export const defaultPageResult = { items: [], pageCount: 0, pageNumber: 1, pageSize: 10, totalItemCount: 0 }
export const defaultFilter = { pageNumber: 1, pageSize: 25, orderColumn: 'amount', orderDescending: true }
export default OrderedPageFilter
